import _ from 'lodash';
import { escapeRegex, takeFirst } from './utils';
import { SearchDataItem } from '../../../../logic/domains/search.domain';

export const getSuggestions = (value: string, data: Array<SearchDataItem>) => {
	var matcher = new RegExp(escapeRegex(value), 'i');

	const predicate = (matcher: RegExp) => (
		searchItem: SearchDataItem
	): Boolean => {
		let foundMatch = false;

		if (searchItem.accountIdList) {
			foundMatch =
				[...searchItem.accountIdList].findIndex(accountId =>
					matcher.test(accountId)
				) >= 0;
		}
		return (
			foundMatch || matcher.test(searchItem.name) || matcher.test(searchItem.id)
		);
	};
	const result = _(takeFirst(30, data, predicate(matcher)))
		.map(item => {
			if (item.accountIdList && item.id.toString().indexOf(value) === -1) {
				const accounts = [...item.accountIdList];
				if (accounts.length === 1) {
					return {
						...item,
						matchedAccountID: accounts[0],
					};
				}

				const exactMatchIndex = _.findIndex(
					accounts,
					accountId => accountId === value
				);

				if (exactMatchIndex > -1) {
					return {
						...item,
						matchedAccountID: value,
					};
				}

				if (accounts.findIndex(accountId => matcher.test(accountId)) >= 0) {
					return _(accounts)
						.sortBy('accountID')
						.compact()
						.map(accountId => {
							if (accountId.indexOf(value) > -1) {
								return {
									...item,
									matchedAccountID: accountId,
								};
							}
							return undefined;
						})
						.compact()
						.value();
				}
			}
			return item;
		})
		.compact()
		.flatten()
		.take(30)
		.sortBy('type')
		.groupBy('type')
		.map((list, key) => ({ title: getByTitle(key), list: _.take(list, 10) }))
		.value();
	return result;
};

const getByTitle = (title: string): string => {
	switch (title) {
		case 'client':
			return 'Clients';
		case 'plan':
			return 'Plans';
		case 'group':
			return 'Groups';
	}
	return title;
};
